import {cn} from '@ds/helpers';

import {PRODUCT_BADGE_LABELS} from './constants';

type ProductBadgeProps = {
  value: string;
  className?: string;
};

const getProductBadgeLabel = (value?: string): string | null => {
  if (value == null || value === '' || value === 'UNSPECIFIED') {
    return null;
  }

  return PRODUCT_BADGE_LABELS[value] ?? value;
};

const ProductBadge: React.FC<ProductBadgeProps> = ({value, className}) => {
  const label = getProductBadgeLabel(value);
  if (label == null) {
    return null;
  }

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded bg-gray-02 px-2.5 py-1 text-body-xs-emphasis',
        className
      )}
    >
      {label}
    </span>
  );
};

export default ProductBadge;
